import React from 'react';

import { AuthCallback } from '@klpkonsern/auth-core/routes';
import { Typography } from '@klp/design';
import { Main } from '@klp/layout';

export const AuthCallbackView: React.FC = () => {
    return (
        <AuthCallback>
            <Main withoutHeader={true} withoutSidebar={true} centered={true}>
                <Typography
                    klpHeadingLevel="ONE"
                    translation="auth.authorizing"
                />
            </Main>
        </AuthCallback>
    );
};
